import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IController, IModule, IOnChangesObject, IScope} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {dersomChangesInneholder} from "../../../../../felles/stoettefunk/angularHjelpemetoder";
import {MøteRessurs} from "../../../../../felles/tjenester/ressurser/MøteRessurs";
import {AvstemningRessurs} from "../../../../../felles/tjenester/ressurser/AvstemningRessurs";

const css = require('./sakAvstemninger.scss');

export class MøteSakAvstemningerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMoeteSakAvstemninger', {
                bindings: {
                    sak: '<',
                    avstemningsstatus: '<'
                },
                controller: MøteSakAvstemningerKontroller.forInjisering(),
                template: require('./sakAvstemninger.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$attrs,
            MøteRessurs.regNavn,
            AvstemningRessurs.regNavn,
            ModelloppdateringTjeneste.regNavn,
            MeldingTilBruker.regNavn,
            Kontekst.regNavn,
            regNavn.gettext.gettextCatalog,
            MøteSakAvstemningerKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $attrs: IAttributes,
                private møteRessurs: MøteRessurs,
                private avstemningRessurs: AvstemningRessurs,
                private modelloppdatering: ModelloppdateringTjeneste,
                private meldingTilBruker: MeldingTilBruker,
                private kontekst: Kontekst,
                private gettextCatalog: gettextCatalog) {
        this.lyttTilAvstemningOpprettet();
        this.lyttTilAvstemningSlettet();
        this.lyttTilMøtedeltakerAvstemningsresultatEndret();
        this.lyttTilMøtedeltakerAvstemningsresultatNullstilt();
    }

    sak: l.AgendaelementModell; //settes via bindings/$onChanges
    avstemningsstatus: l.AvstemningsstatusModell //settes via bindings/$onChanges, lastes via $onChanges dersom ikke angitt som attributt 
    
    $onChanges(endringer: IOnChangesObject) {
        dersomChangesInneholder(endringer, 'sak', sak => this.initStatus(sak));
    }

    //hjelpemetoder
    
    private initStatus(sak: l.AgendaelementModell){
        //last status kun dersom avstemningsstatus ikke er angitt som attributt
        if (this.$attrs['avstemningsstatus']) return;
        
        this.møteRessurs.avstemningsstatus(sak.moete.id).$promise
            .then((status: l.AvstemningsstatusModell) => this.avstemningsstatus = status);
    }
    
    //modelloppdateringslyttere

    private lyttTilAvstemningOpprettet() {
        this.modelloppdatering.vedNyAvstemning(
            ny => this.sak.id === ny.sakId && !_(this.sak.avstemninger).some({id: ny.avstemningId}),
            this.$scope,
            ny => {
                this.avstemningRessurs.hent(ny.avstemningId).$promise
                    .then(avstemning => {
                        if (_(this.sak.avstemninger).some({id: avstemning.id})) return;
                        this.sak.avstemninger.push(avstemning);
                        this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Ny avstemning lagt til sak")); 
                    });
            });
    }
    
    private lyttTilAvstemningSlettet() {
        this.modelloppdatering.vedSlettetAvstemning(
            slettetId => _(this.sak.avstemninger).some(b => b.id === slettetId),
            this.$scope,
            slettetId => {
                _.remove(this.sak.avstemninger, b => b.id === slettetId);
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Avstemning slettet"));
            });
    }

    private lyttTilMøtedeltakerAvstemningsresultatEndret() {
        this.modelloppdatering.vedMøtedeltakerAvstemningsresultatEndret(
            info => this.sak.moete.id == info.moeteId,
            this.$scope,
            info => {
                this.initStatus(this.sak);
            });
    }

    private lyttTilMøtedeltakerAvstemningsresultatNullstilt() {
        this.modelloppdatering.vedMøtedeltakerAvstemningsresultatNullstilt(
            info => this.sak.moete.id == info.moeteId,
            this.$scope,
            info => {
                this.initStatus(this.sak);
            });
    }
}


